import { connect } from 'react-redux';
import { resolveWaitForModal } from 'components/Modal';
import NotListedPlatformModal from './NotListedPlatformModal';

const mapDispatchToProps = dispatch => ({
  handleOnSubmit: formValues => dispatch(resolveWaitForModal(formValues)),
  handleOnCancel: () => dispatch(resolveWaitForModal(false)),
});

export default connect(null, mapDispatchToProps)(NotListedPlatformModal);
